<template>
  <div>
    <ParentBar />
    <PermissionValidation :marketId="marketId" rule="enableViewAreaInterests">
      <layout :isSuccess="true">
        <template v-slot:headZone>
          <headline :content="`${$t('area.area_interest')}`">
            <div class="d-flex align-top">
              <v-tooltip top color="success" >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-text-field
                      :value="interestUrl"
                      outlined
                      dense
                      type="text"
                      :placeholder="$t('search')"
                      hide-details
                      class="ms-10 me-3"
                      style="width: 550px;"
                      prepend-inner-icon="mdi-link"
                      readonly
                      
                    >
                      <template v-slot:prepend-inner>
                        <v-icon style="margin-top: 0px; font-size: 31px;">mdi-link</v-icon>
                      </template>
                      <template v-slot:append>
                        <v-btn v-if="!isCopied" style="margin: -3px -6px 5px auto;" color="primary" elevation="0" @click="copyToClipboard(interestUrl)">
                          <v-icon left>mdi-content-copy</v-icon>
                          {{ $t('url.copy_url') }}
                        </v-btn>
                        <v-btn v-else style="margin: -3px -6px 5px auto; background-color: #ADADAD; pointer-events: none;" text dark elevation="0" @click="copyToClipboard(interestUrl)">
                          <v-icon left>mdi-content-copy</v-icon>
                          {{ $t('url.copied') }}
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </template>
                <span>{{ $t('url.interest_do_business_url') }}</span>
              </v-tooltip>
              <interest-manager @onClickCreate="createObject"></interest-manager>
            </div>
            <template v-slot:append-content>
              <div class="d-flex align-center gap-2">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  :placeholder="$t('search')"
                  prepend-inner-icon="mdi-magnify"
                  v-model="searchText"
                  clearable
                  color
                  hide-details
                  class="ms-10"
                  style="width: 250px;"
                ></v-text-field>
                <v-btn @click="exportInterest()" class="blue white--text mx-1" :disabled="loading">
                  <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
                </v-btn>
              </div>
            </template>
          </headline>
        </template>
        <template v-slot:containerZone>
          <interest-list :loading="loading" @onClickEdit="updateObject" @onInit="init" :search="searchText"></interest-list>
        </template>
      </layout>
      <template>
        <interest-dialog
          v-model="isInterest"
          :isCreate="form.isCreate"
          :isUpdate="form.isUpdate"
          :objectId="form.objectId"
          @onSuccess="isInterest = false"
          @onCreate="
            afterCreate($event);
            init();
          "
          @onUpdate="
            afterCreate($event);
            init();
          "
        ></interest-dialog>
      </template>
    </PermissionValidation>
  </div>
</template>

<script>
import Headline from "../../components/Headline.vue";
import InterestList from "../../components/InterestList.vue";
import InterestManager from "../../components/InterestManager.vue";
import Layout from "../../components/Layout.vue";
import ParentBar from "../../components/ParentBar.vue";
import InterestDialog from "../../components/InterestDialog.vue";
import { mapGetters } from "vuex";
import FormCustomer from "../../components/FormCustomer.vue";
import FormContract from "../../components/FormContract.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
import { ExportAreaInterest } from "../../exports";
export default {
  components: {
    Layout,
    ParentBar,
    Headline,
    InterestList,
    InterestManager,
    InterestDialog,
    FormCustomer,
    FormContract,
    PermissionValidation
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isInterest: false,
      loading: false,
      form: {
        isCreate: false,
        isUpdate: false,
        objectId: null
      },
      isCustomer: false,
      isContract: false,
      searchText: "",
      isCopied: false
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      areaInterest: "areaInterest/areaInterest",
      customer: "customer/getCustomer",
      contract: "contract/getContract",
      areaInterests: "areaInterest/areaInterests",
    }),
    interestUrl() {
      const langParam = this.$globalLocale == 'la' ? `&lang=lo` : '';
      return `${process.env.VUE_APP_INTEREST_URL}/i/${this.projectId}?market=${this.marketId}${langParam}`;
    }
  },
  watch: {
    marketId(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    afterCreate(object) {
      if (this.form.isCreate) {
        this.isInterest = false;
      }
    },
    updateObject(object) {
      this.form.isUpdate = true;
      this.form.isCreate = false;
      this.form.objectId = object.objectId;
      this.isInterest = true;
    },
    createObject() {
      this.form.isCreate = true;
      this.form.isUpdate = false;
      this.form.objectId = null;
      this.isInterest = true;
    },
    async init() {
      await this.getAreaInterests();
    },
    async getAreaInterests() {
      try {
        // from store
        this.loading = true;
        const areaInterest = await this.$store.dispatch(
          "areaInterest/getAreaInterests",
          { marketId: this.marketId }
        );

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    formData() {
      this.form = {
        id: this.areaInterest.objectId,
        ...this.areaInterest
      };
    },
    copyToClipboard(url) {
      navigator.clipboard.writeText(url);
      this.$toast.show({
        content: this.$t('url.copy_success'),
        color: "success"
      });
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 3000);
    },
    exportInterest() {
      ExportAreaInterest.exportAreaInterest(this.areaInterests);
    }
  }
};
</script>

<style>
</style>